export default "__VITE_ASSET__Ci48vlW1__"